import { o_global } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import {
  activate,
  activateLegacy,
  setColors,
  deactivate,
  logger,
  scope,
  updateWriter,
  setLevel,
} from "./head/debug.js";
import { Level } from "./head/level.js";
import { status, updateStatus } from "./head/status.js";
import { readCookies } from "./head/cookie.js";
import type { AsyncNamespace } from "../nexus/namespace/namespace.types";
import type { NexusResult } from "../nexus/function/function.types.js";
import type { APMLabelsMap } from "../apm/async/captureError.js";

/**
 *
 */
export type GlobalDebug = {
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  logger: typeof logger;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  scope: typeof scope;

  /**
 *
 */
  Level: typeof Level;

  /**
 *
 */
  status: typeof status;

  /**
 *
 */
  setColors: typeof setColors;

  /**
 *
 */
  setLevel: typeof setLevel;

  /**
 *
 *
 *
 *
 */
  activate: typeof activate;

  /**
 *
 *
 *
 *
 */
  deactivate: typeof deactivate;
};

/*                            */
updateWriter(updateStatus(readCookies()));

/*                                              */
assignNamespace(
  o_global,
  "debug",
  {
    activate,
    deactivate,
    logger,
    scope,
    Level,
    status,
    setColors,
    setLevel,
  },
  {
    activateLegacy,
    warn: logger("legacy.warn").warn,
  },
);

declare global {
  interface NexusInterfaces {
    /**
 *
 *
 */
    debug: AsyncNamespace<{
      /*                      */
      sendLog(namespace: string, labels: APMLabelsMap): NexusResult<Promise<null>>;
    }>;
  }
}
